
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { SupportRequestState } from "@api/schema";
import BaseLayout from "@components/BaseLayout";
import HtmlContent from "@components/common/HtmlContent";
import SupportRequestScroller from "@components/entityTypes/supportRequest/SupportRequestScroller";
import ErrorPage from "@components/ErrorPage";
import { withDynamicNamespaces } from "@components/hoc/withDynamicNamespaces";
import MarketFilterTabs, { MarketTabItems } from "@components/marketplace/MarketFilterTabs";
import PartnerMarketForm from "@components/usecases/partnerMarket/PartnerMarketForm";
import { IFilteredCollectionState } from "@redux/helper/reducers";
import { NamespaceShortcut, useDynamicTranslation } from "@services/i18n";
import { initialPartnerMarketSearchState, IPartnerMarketSearchParams, IPartnerMarketSortType, ISupportRequestFilterCriteria } from "@services/partnermarketHelper";
import { MODULE_PARTNER_MARKET_AVAILABLE } from "config";
const usedNamespaces: NamespaceShortcut[] = ["common", "partner-market", "base-layout"];
/**
 * this page provides the entry to the PartnerMarket, showing SupportRequests of projects
 */
const PublicPartnerMarketPage: React.FC = () => {
    const t = useDynamicTranslation();
    const [supportRequestsLoadingState, setSupportRequestsLoadingState] = useState<IFilteredCollectionState>();
    // criteria to be sent to the API
    // initially null to avoid running the search twice
    // filterCriteria is calculated and set by useEffect
    const [criteria, setCriteria] = useState<ISupportRequestFilterCriteria>(null);
    // represents the current state of the search form
    const [partnerMarketSearchState, setPartnerMarketSearchState] = useState<IPartnerMarketSearchParams>(initialPartnerMarketSearchState);
    // translate a change search state to search criteria for the API
    useEffect(() => {
        // map sortBy and sortOrder from the searchform into one criteria
        let orderCriteria: ISupportRequestFilterCriteria = {};
        switch (partnerMarketSearchState.sortBy) {
            case IPartnerMarketSortType.PublicUntil:
                orderCriteria = {
                    "order[publicUntil]": partnerMarketSearchState.sortOrder
                };
                break;
            case IPartnerMarketSortType.UpdatedAt:
                orderCriteria = {
                    "order[updatedAt]": partnerMarketSearchState.sortOrder
                };
                break;
            default: break;
        }
        setCriteria({
            // make sure to show only published SupportRequests to avoid
            // that a logged in user gets unpublished support requests from his project
            "state": SupportRequestState.Public,
            // Workaround for https://futureprojects.atlassian.net/browse/FCP-1376
            // b/c “uppercase umlaute” like “Ü” are currently not supported by the api
            // adapted the criteria and not the form itself,
            // because the user input should not be changed to avoid confusion
            pattern: partnerMarketSearchState.pattern.toLocaleLowerCase(),
            supporterRole: partnerMarketSearchState.supporterRoles,
            ...orderCriteria
        });
    }, [JSON.stringify(partnerMarketSearchState)]);
    if (!MODULE_PARTNER_MARKET_AVAILABLE) {
        return <ErrorPage statusCode={404} error={t("error", "failure.moduleNotAvailable")}/>;
    }
    if (supportRequestsLoadingState?.loaded && supportRequestsLoadingState?.loadingError) {
        return <ErrorPage statusCode={404} error={supportRequestsLoadingState.loadingError}/>;
    }
    const onSubmit = (values: IPartnerMarketSearchParams): void => {
        setPartnerMarketSearchState(values);
    };
    return <BaseLayout pageTitle={t("partner-market", "page.marketpage.title")}>
    <Row>
      <Col className="col text-center">
        <MarketFilterTabs chosenItem={MarketTabItems.SupportRequests}/>
      </Col>
    </Row>
    <Row>
      <Col>
        <HtmlContent content={t("partner-market", "page.marketpage.description")}/>
      </Col>
    </Row>
    <Row>
      <Col>
        <PartnerMarketForm searchParams={partnerMarketSearchState} onSubmit={onSubmit}/>
      </Col>
    </Row>
    <SupportRequestScroller filterCriteria={criteria} withSupportOfferCreateButton={true} setSupportRequestsLoadingState={setSupportRequestsLoadingState} showLoadingInformation showTotalItemCount/>
  </BaseLayout>;
};
const __Next_Translate__Page__191dbbefb21__ = withDynamicNamespaces(PublicPartnerMarketPage, usedNamespaces);

    export default __appWithI18n(__Next_Translate__Page__191dbbefb21__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  